export const cleanTitle = (t) =>
  (t || "")
    .replace(/_/g, " ")
    .replace(/--/g, " ")
    .replace(/-/g, " ")
    .replace(/\b[a-f0-9]{8,}\b/gi, "")
    .replace(/\b\d+[a-z]+\d*[a-z]*\d*\b/gi, "")
    .replace(/\b[a-z]+\d+[a-z]*\d*[a-z]*\b/gi, "")
    .replace(/\d+/g, "")
    .replace(/\b[a-z]{1,5}\b/g, "")
    .replace(/\s+/g, " ")
    .trim();

function parseAck(val) {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "string") {
    try {
      const parsed = JSON.parse(val);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

/**
 * Map raw awsEvents -> { accounts, accountDetails, eventIndex }
 */
export function mapAws(awsEvents) {
  if (!awsEvents || typeof awsEvents !== "object") {
    return { accounts: [], accountDetails: {}, eventIndex: {} };
  }

  const accounts = [];
  const accountDetails = {};
  const eventIndex = {};

  for (const [id, acc] of Object.entries(awsEvents)) {
    const name = acc?.account_name || id;
    const env = acc?.environment || "-";
    const self_account = acc?.self_account || false;
    const services = acc?.business_service ? [acc.business_service] : [];

    const events = Array.isArray(acc?.events)
      ? acc.events.map((e) => {
          const eventId = e.release_id || e.eventId || "";
          const title = e.release_title || e.title || "";
          const ack = parseAck(e.ack);
          const impacted_completed = typeof e.impacted_completed === "number"
            ? e.impacted_completed
            : Number.isFinite(Number(e.impacted_completed))
              ? Number(e.impacted_completed)
              : -1
          return {
            eventId,
            title,
            impact: e.relevance || e.impact,
            actionRequired: e.what_action_needed || e.actionRequired,
            planned_start_date: e.planned_start_date || "N/A",
            planned_end_date: e.planned_end_date || "N/A",
            status: e.release_status || e.status,
            region: e.region,
            impacted_services: e.impacted_services,
            category: e.category,
            act_by: e.act_by || "N/A",
            summary: e.summary,
            last_updated: e.last_updated,
            release_url: e.release_url,
            ack,
            impacted_completed,
          };
        })
      : [];

    accounts.push({ id, name, env, self_account, services, total: events.length });
    accountDetails[id] = events;
  }

  const accById = {};
  accounts.forEach((a) => (accById[a.id] = a));

  for (const [accId, list] of Object.entries(accountDetails)) {
    const environment = accById[accId]?.env ?? null;
    const vendor_service = accById[accId]?.services?.[0] ?? null;

    (list || []).forEach((ev) => {
      if (!ev.eventId) return;
      eventIndex[ev.eventId] = {
        release_id: ev.eventId,
        full_title: ev.title,
        release_title: cleanTitle(ev.title),
        release_status: ev.status,
        relevance: ev.impact,
        vendor_service,
        planned_start_date: ev.planned_start_date,
        planned_end_date: ev.planned_end_date,
        what_action_needed: ev.actionRequired,
        region: ev.region,
        impacted_services: ev.impacted_services,
        category: ev.category,
        act_by: ev.act_by,
        summary: ev.summary,
        environment,
        last_updated: ev.last_updated,
        release_url: ev.release_url,
        ack: ev.ack || [],
        impacted_services: ev.impacted_services,
      };
    });
  }

  return { accounts, accountDetails, eventIndex };
}
